'use strict';

var React = require('react');
var InputMask = require('react-input-mask');
var reactUtils = require('@sravni/react-utils');
var TextInput = require('../../TextInput/src/TextInput.js');
var MaskInput_module = require('../styles/MaskInput.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Mask Input component allows user to type in text with mask
 *
 * @component
 * @example
 * ```jsx
 * <MaskInput placeholder="Дата" mask="99/99/9999" value={value} onChange={handleChange} />
 * ```
 */
const MaskInput = React__namespace.forwardRef((props, ref) => {
    const { defaultValue, value, mask, placeholder, className, onChange, ...restProps } = props;
    const [innerValue, setInnerValue] = React__namespace.useState(value || defaultValue);
    const formControlContext = reactUtils.useFormControlContext();
    const cx = reactUtils.useStyles(MaskInput_module.default);
    const classNames = cx(className, 'container');
    const inputProps = React__namespace.useMemo(() => ({
        ...formControlContext,
        ...restProps,
    }), [restProps, formControlContext]);
    const handleChange = (event) => {
        setInnerValue(event.currentTarget.value);
        onChange?.(event.currentTarget.value);
    };
    React__namespace.useEffect(() => {
        reactUtils.isDefined(value) && setInnerValue(value);
    }, [value]);
    return (React__namespace.createElement("div", { "data-qa": "MaskInput", className: classNames },
        React__namespace.createElement(InputMask, { mask: mask, value: innerValue, onChange: handleChange, ...inputProps },
            React__namespace.createElement(TextInput.TextInput, { ref: ref, placeholder: placeholder }))));
});
MaskInput.defaultProps = {};
MaskInput.displayName = 'MaskInput';

exports.MaskInput = MaskInput;
//# sourceMappingURL=MaskInput.js.map
